import { Moment } from "packages/moment";

export const getProduceMomentDate = (momentDate: Moment): Date => {
  return new Date(momentDate.get("year"), momentDate.get("month"), momentDate.get("date"), momentDate.get("hour"), momentDate.get("minute"));
};
